import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

/**
 * A simple component to display a progress bar with optional text.
 * The progress value can be dynamically updated, and the text provides additional context.
 */
@Component({
  selector: "app-progress-bar",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./progress-bar.component.html",
  styleUrl: "./progress-bar.component.scss",
})
export class ProgressBarComponent {
  private _progress = 0;

  @Input()
  set progress(value: number) {
    const numeric = Number(value);
    const next = Number.isFinite(numeric)
      ? Math.max(0, Math.min(100, numeric))
      : 0;
    // Keep the bar monotonic unless the parent resets (0) or completes (100).
    if (next === 0 || next >= 100 || next >= this._progress) {
      this._progress = next;
    }
  }
  get progress(): number {
    return this._progress;
  }

  @Input() text: string = "progress bar";
  @Input() isError = false;
}
